import template   from './product-filters.html'
import controller from './product-filters.controller'

let component = {
  restrict: 'E',
  bindings: {
    filter: '='
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-filters/product-filters.component.js